<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp3',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-3">
    <module-title :title="moduleOption.title" margin-bottom="28" />
    <div class="comp-transverse-3 modules-id-3-content">
      <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-3-${v.id}`"
        class="item"
        :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
        @click="onModuleItem(v)"
      >
        <el-image class="images" :src="v.photo | imgPath" alt="images" fit="cover" />
        <p class="title">{{ v.headline | textLenHandler(40) }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-3-content {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  .item {
    width: 450px;
    height: 151px;
    background: #fff;
    border-radius: 5px;
    padding: 6px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .images {
    width: 157px;
    height: 139px;
    border-radius: 5px;
  }
  .title {
    width: 260px;
    font-size: 17px;
    font-weight: 800;
    color: #000;
    text-align: start;
    line-height: 25px;
    margin-left: 18px;
  }
}
</style>
